<div class="main-container">
  <app-reset-password-form
    [code]="code"
    [isModal]="true"
    (resetPasswordFormSubmit)="resetPasswordFormSubmit()"
    (backClick)="backClick()"
  ></app-reset-password-form>
</div>
